import { StyleSheet, Platform } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorBgPrimaryLight, colorBgBase, borderRadius5, space4, space6 } = theme();

  return StyleSheet.create({
    contentList: {
      backgroundColor: colorBgPrimaryLight,
      display: "flex",
      ...Platform.select({
        web: {
          flexWrap: "wrap",
        },
      }),
    },
    contentListDesktop: {
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "center",
      maxWidth: 1920,
      ...Platform.select({
        web: {
          gap: space6,
        },
      }),
    },
    contentListMobile: {
      ...Platform.select({
        web: {
          flexDirection: "column",
          alignItems: "stretch",
        },
      }),
    },
    lookCollageWrapper: {
      backgroundColor: colorBgBase,
      borderRadius: borderRadius5,
      maxWidth: "100%",
      width: 375,
    },
    lookCollageWrapperMobile: {
      flex: 1,
      marginBottom: space4,
    },
  });
};

export { style };
